// Helper function to pad numbers
export function pad(number, length) {
    let str = '' + number;
    while (str.length < length) {
        str = '0' + str;
    }
    return str;
}

// Function to handle file selection and set the base URI
export function handleFileSelect(file, baseUrl) {
    const indexOfQueryStart = baseUrl.indexOf("?");
    const submitUri = baseUrl.substring(0, indexOfQueryStart) + '/' + file.name + baseUrl.substring(indexOfQueryStart);
    return  submitUri ;
}

// Function to upload a chunk
export async function uploadChunk(submitUri, data, blockId) {
    const uri = submitUri + '&comp=block&blockid=' + blockId;
    const requestData = new Uint8Array(data);
    const requestOptions = {
        method: 'PUT',
        headers: {
            "accept": "application/json",
            "Access-Control-Allow-Origin": "*",
            'x-ms-blob-type': 'BlockBlob',
            'Content-Length': requestData.length
        },
        body: requestData,
        processData: false,
        crossDomain: true,
    };

    const response = await fetch(uri, requestOptions);
    if (response.ok) {
        console.log("Chunk uploaded successfully");
    } else {
        throw new Error("Chunk upload failed");
    }
}

export async function commitBlockList(submitUri, blockIds, selectedFile) {
    const uri = `${submitUri}&comp=blocklist`;
    const blockListXML = `<BlockList>${blockIds.map(id => `<Latest>${id}</Latest>`).join('')}</BlockList>`;

    const requestOptions = {
        method: 'PUT',
        headers: {
            "accept": "application/xml",
            "Access-Control-Allow-Origin": "*",
            'x-ms-blob-content-type': selectedFile.type
        },
        body: blockListXML,
        crossDomain: true,
    };

    const response = await fetch(uri, requestOptions);
    if (response.ok) {
        console.log("Block list committed successfully");
        return response.url.split('?')[0];
    } else {
        throw new Error("Failed to commit block list");
    }
}
